import { STLExporter } from 'three/examples/jsm/exporters/STLExporter';

export default {
    methods: {
        async loadDentalMap(file) {
            if (file) {
                const reader = new FileReader();
                reader.onload = (e) => {
                    const content = e.target.result;
                    try {
                        const newDentalMap = JSON.parse(content);
                        try {
                            this.addEigenvectorsToDentalMap(newDentalMap);
                        } finally {
                            this.dentalMap = { ...this.dentalMap, ...newDentalMap };
                        }
                        this.executeActionWithLoading('createDentalMesh', () => {
                            this.createDentalMeshGroup(newDentalMap);
                            this.createBoundingBoxMeshForTeeth(false);
                        }, 500);
                    } catch (error) {
                        console.error('Erro ao ler o arquivo JSON:', error);
                    }
                };
                reader.readAsText(file);
            }
        },

        exportSTL() {
            if (!this.activeObject) {
                console.error('Não há objeto ativo selecionado para exportar.');
                return;
            }

            const exporter = new STLExporter();
            const options = { binary: true };
            const stlString = exporter.parse(this.activeObject, options);
            const blob = new Blob([stlString], { type: 'application/octet-stream' });

            const link = document.createElement('a');
            link.style.display = 'none';
            document.body.appendChild(link);
            link.href = URL.createObjectURL(blob);
            link.download = (this.activeObject.userData.name) ? 
                `${this.activeObject.userData.name}.stl` : 'ortho-model.stl';
            link.click();

            URL.revokeObjectURL(link.href);
            document.body.removeChild(link);
        },

        async fetchFileList() {
            fetch(`${process.env.VUE_APP_API_URL}models`)
                .then(response => response.json())
                .then(data => {
                    this.fileList = data;
                    this.showFileDialog = true;
                })
                .catch(error => console.error('Erro ao recuperar dados:', error));
        },

        loadFile(file) {
            this.showFileDialog = false;
            this.$refs.progressDialog.showProgressDialog("Carregando e Preparando STL. Aguarde...", 10);
            setTimeout(() => { this.dbLoadModel(file.id); }, 1000);
        },

        deleteFile(file, all = false) {
            this.showFileDialog = false;
            this.$refs.progressDialog.showProgressDialog("Removendo dados do servidor. Aguarde...", 10);
            setTimeout(() => { this.dbDeleteDentalMap(file.id, all); }, 1000);
        },

        saveImageAsync(imageURL, filename) {
            return new Promise((resolve) => {
                const link = document.createElement("a");
                link.href = imageURL;
                link.download = filename;
                link.style.display = "none";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                resolve();
            });
        },

        saveImage(imageURL, filename) {
            const link = document.createElement("a");
            link.href = imageURL;
            link.download = filename;
            link.style.display = "none";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },

        formatFileSize(size) {
            return (size / 1024 / 1024).toFixed(2) + ' MB';
        }
    }
}
